import { render, staticRenderFns } from "./insandRepair.vue?vue&type=template&id=02180fc6&scoped=true"
import script from "./insandRepair.vue?vue&type=script&lang=js"
export * from "./insandRepair.vue?vue&type=script&lang=js"
import style0 from "./insandRepair.vue?vue&type=style&index=0&id=02180fc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02180fc6",
  null
  
)

export default component.exports